module.exports = __webpack_public_path__ + "img/banner-1.0a1b7f46.png";